import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };

import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import { computed, ref } from 'vue';

    interface DirectFlightFilterProps {
        modelValue: boolean;
        isHover?: boolean;
        size?: 'small' | 'medium';
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DirectFlightFilter',
  props: {
    modelValue: { type: Boolean },
    isHover: { type: Boolean, default: false },
    size: { default: 'small' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'update:modelValue', value: boolean): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, isHover: boolean, size: 'small' | 'medium' }

    

    

    const model = computed({
        get: () => props.modelValue,
        set: (v: boolean) => emit('update:modelValue', v),
    });
  

return { __sfc: true,props, emit, model, CheckBoxInput, TextCommon }
}

})